import React from "react";
import * as moment from "moment";


export function HeaderColumnFormatter(cellContent) {
    return (
        <span className={'text-primary fs-7'}>{cellContent}</span>
    );
}
